<template>
  <div class="center-warp">
    <div class="inner">
      <div class="title">
        <div class="d-flex">
          <div class="top-search" style="width: 210px !important;">
            <Input :placeholder="'搜索病例姓名'" v-model="meetingOpt.patient_name" @enter="initData"/>
            <div class="iconfont icon-sousuo" @click="initData"></div>
          </div>
          <div class="top-search" style="width: 210px !important;">
            <Input :placeholder="'搜索发起人姓名'" v-model="meetingOpt.from_member_name" @enter="initData"/>
            <div class="iconfont icon-sousuo" @click="initData"></div>
          </div>
          <div class="reset-btn" @click="handleReset">重置</div>
        </div>
        <!--   创建   -->
        <button class="createBtn" @click="openMeetingDialog" v-if="member.member_type == 1">
          <i class="iconfont icon-xinzeng"></i>创建会诊
        </button>
      </div>
      <!--  病人卡片  -->
      <div class="cardList" v-loading="loading">
        <template v-if="meetingList.length">
        <div class="card-item hover-shadow" v-for="item in meetingList" @click="goPage(item)">
          <div class="person">
            <img class="touxiang" :src="item.patient.head_pic" />
            <div class="personInfo">
              <div class="d-flex-between">
                <span class="name">{{item.patient.name}}</span>
                <div class="id_name">{{item.patient.age_text}}</div>
              </div>
              <div class="id_name d-flex-between">
                <div>ID:{{item.patient.no}}</div>
                <!--判断显示病例类型-->
                <div class="case-person-cycle package-tag" :class="item.patient.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{item.patient.confirm_first_case_type_text != '' ? item.patient.confirm_first_case_type_text :item.patient.first_case_type_name}}</div>
              </div>
            </div>
          </div>
          <div class="consultationTime"><img src="@/assets/img/consultation_room/consultationTime.png" />{{item.start_time2}}<span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>{{item.end_time2}}</div>
          <!-- 病情论述-->
          <div class="info">
            病情概述：{{item.remark}}
          </div>
          <!--        分割线-->
          <div class="line"></div>
          <!-- 发起人  -->
          <span class="startPerson">发起人：<img :src="item.from_member_headpic" /> {{item.from_member_name}}</span>
        </div>
        </template>
        <Empty style="margin-top: 20vh" v-else :info="'暂无会诊'" :img-width="'200px'"></Empty>
      </div>

      <MeetingDialog ref="meetingDialog" :caseDetailValue="caseDetailValue" @createOk="initData" />

    </div>
  </div>
</template>

<script>
import { GetCaseCardList, GetJoinedMeeting } from "@/http/api";
import MeetingDialog from "@/views/consultation_room/components/MeetingDialog";

export default {
  name: "index",
  components: { MeetingDialog },
  data() {
    return {
      meetingList: [],
      meetingOpt: {
        patient_name: "",
        from_member_name: "",
      },
      caseDetailValue: {},
      loading: false,
      member: {},
    };
  },
  mounted() {
    this.$store.commit("breadChange", { name: "会诊室", isBack: false });
    this.member = JSON.parse(localStorage.getItem("member"));
    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      GetJoinedMeeting(this.meetingOpt).then((res) => {
        this.meetingList = res.data;
        this.loading = false;
      });
    },
    handleReset(){
      this.meetingOpt = {
        patient_name: "",
        from_member_name: "",
      }
      this.initData()
    },
    //打开创建病例弹窗
    openMeetingDialog() {
      this.caseDetailValue = {};
      //清空弹窗选择病例
      this.$refs.meetingDialog.openCreateMeeting({});
    },
    goPage(item) {
      GetCaseCardList({
        patient_id: item.patient_id,
        type_id: 0,
        pageSize: 999,
      }).then((res) => {
        this.$router.push({
          name: "会诊室详情",
          query: {
            meeting_id: item.id,
            case_id: item.patient_id,
            card_id: res.data[0].id,
          },
        });
      });
    },
  },
};
</script>

<style scoped src="../../assets/css/consultation_room.css"></style>

